import { render } from "./commentsContainer.vue?vue&type=template&id=6c1dce8a&scoped=true&ts=true"
import script from "./commentsContainer.vue?vue&type=script&lang=ts"
export * from "./commentsContainer.vue?vue&type=script&lang=ts"

import "./commentsContainer.vue?vue&type=style&index=0&id=6c1dce8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1dce8a"]])

export default __exports__